export const WorkerSettings = {
    detectors: [
        [3, 0, 3, 0.005, 3, 1],
        [3, 0, 3, 0.001, 10, 10],
    ],
    detectorFrequency: 5000,
    trackingLostTimeout: 200,
};
